'use strict';

function hideSpinner(selector) {
    jQuery(selector).empty();
}

function showSpinner(selector) {
    jQuery(selector).html('' +
      '<div class="spinner-fading-circle">\n' +
      '  <div class="spinner-circle1 spinner-circle"></div>\n' +
      '  <div class="spinner-circle2 spinner-circle"></div>\n' +
      '  <div class="spinner-circle3 spinner-circle"></div>\n' +
      '  <div class="spinner-circle4 spinner-circle"></div>\n' +
      '  <div class="spinner-circle5 spinner-circle"></div>\n' +
      '  <div class="spinner-circle6 spinner-circle"></div>\n' +
      '  <div class="spinner-circle7 spinner-circle"></div>\n' +
      '  <div class="spinner-circle8 spinner-circle"></div>\n' +
      '  <div class="spinner-circle9 spinner-circle"></div>\n' +
      '  <div class="spinner-circle10 spinner-circle"></div>\n' +
      '  <div class="spinner-circle11 spinner-circle"></div>\n' +
      '  <div class="spinner-circle12 spinner-circle"></div>\n' +
      '</div>');
}
